'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "trackId", "lessonId", "option"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useLanguageRequested from '../../hooks/useLanguageRequests';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RequestButton = styled.span.withConfig({
  displayName: "RequestLanguageButton__RequestButton",
  componentId: "c4h59e-0"
})(["", " ", " padding:8px 20px;"], ({
  disabled
}) => disabled ? '' : `color: ${CALYPSO_DARK} !important;`, ({
  disabled
}) => disabled ? '' : `cursor: pointer;`);
const RequestLanguageButton = _ref => {
  let {
      children,
      trackId,
      lessonId,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [languageRequested, setLanguageRequested] = useLanguageRequested({
    trackId,
    lessonId,
    language: option.value
  });
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !option.disabled,
    headingText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.requestLanguage.notAvailable`,
      options: {
        language: option.text
      }
    }),
    maxWidth: 400,
    placement: "left",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.requestLanguage.${languageRequested ? 'requested' : 'request'}.tooltip`
    }),
    children: /*#__PURE__*/_jsxs(UIFlex, Object.assign({
      align: "center",
      justify: "between"
    }, rest, {
      children: [children, option.disabled && /*#__PURE__*/_jsx(RequestButton, {
        disabled: languageRequested,
        onClick: setLanguageRequested,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.requestLanguage.${languageRequested ? 'requested' : 'request'}.button`
        })
      })]
    }))
  });
};
RequestLanguageButton.propTypes = {
  children: PropTypes.node,
  lessonId: PropTypes.string,
  option: PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.string,
    disabled: PropTypes.bool
  }),
  trackId: PropTypes.string
};
export default RequestLanguageButton;